export default __webpack_public_path__ + "static/media/prospects_nav_icon.d151f132.svg";